export class SocialApiMaintenanceError extends Error {
  constructor() {
    super('Social API is under maintenance');
    this.name = 'SocialApiMaintenanceError';
  }
}

export default SocialApiMaintenanceError;
